import axios from "axios";
import { getAccessToken } from "../Helper/user.helper";

export const post = ({
  url,
  body = {},
  params = {},
  includeAccessToken = true,
}: {
  url: string;
  body?: object;
  params?: object;
  includeAccessToken?: boolean;
}) => {
  let headers: {
    Authorization?: string | null;
  } = {};
  if (includeAccessToken) {
    const accessToken = getAccessToken();
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return axios
    .post(url, body, {
      headers,
      params,
    })
    .then((response) => {
      return response.data?.responseData;
    });
};

export const get = async ({
  url,
  params = {},
  includeToken = true,
}: {
  url: string;
  params?: object;
  includeToken?: boolean;
}) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "",
  };

  const requestParams = {
    ...params,
  };

  if (includeToken) {
    const token = getAccessToken();
    headers.Authorization = `Bearer ${token}`;

    /*    requestParams.accessToken = token; */
  }

  return axios
    .get(url, {
      headers,
      params: requestParams,
    })
    .then((response) => {
      return response.data?.responseData;
    })
    .catch((error) => {
      throw Error(error);
    });
};

export const put = async ({
  url,
  body = {},
  params = {},
  includeAccessToken = true, // Might need later but not now
}: {
  url: string;
  body: any;
  params?: object;
  includeAccessToken?: boolean;
}) => {
  let headers: {
    Authorization?: string | null;
  } = {};

  if (includeAccessToken) {
    const accessToken = getAccessToken();
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return axios.put(url, body, {
    headers,
    params,
  });
};

export const patch = async ({
  url,
  body = {},
  params = {},
  includeAccessToken = true,
}: {
  url: string;
  body: any;
  params?: object;
  includeAccessToken?: boolean;
}) => {
  let headers: {
    Authorization?: string | null;
    "Content-Type": string;
  } = {
    "Content-Type": "application/json",
  };

  if (includeAccessToken) {
    const accessToken = getAccessToken();
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return axios.patch(url, body, {
    headers,
    params,
  });
};

export const deleteApi = async (
  url: string,
  includeToken = true,
  parameters: object = {}
) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "",
  };

  const params = {
    accessToken: "",
    ...parameters,
  };

  if (includeToken) {
    const token = getAccessToken();
    headers.Authorization = `Bearer ${token}`;
    params.accessToken = token as string;
  }

  return axios
    .delete(url, {
      headers,
      params,
    })
    .then((response) => {
      return response.data?.responseData;
    })
    .catch((error) => {
      throw Error(error);
    });
};
